/**
 * Created by ah on 04/01/17.
 */
import api from '../apiClient';
import {Keys, Actions} from '../constants';
import {defaultAsyncActionFactory} from './action-utils'

export const loadAccount =  defaultAsyncActionFactory(
    Actions.GET_ACCOUNT,
    Keys.StoreSliceData.ACCOUNT,
    api.getAccount
);


// WEBPACK FOOTER //
// ./src/model/action-creators/account-actions.js